// extracted by mini-css-extract-plugin
module.exports = {"copy":"Footer_copy__3o-cR","footer":"Footer_footer__3g2mj","trade":"Footer_trade__3NPAC"};